// Names of supporteds and coordinators are written in Hebrew letters only. Spaces separate
// words, and a geresh (' or ׳) is kept for names like צ'רני. Everything else -- Latin letters,
// digits, niqqud and symbols such as * / - -- is not part of a name.
const HEBREW_NAME_PATTERN = /^[א-ת'׳ ]*$/;
const NOT_HEBREW_NAME_CHAR = /[^א-ת'׳ ]/g;

export function isHebrewName(name: string): boolean {
  return HEBREW_NAME_PATTERN.test(name);
}

// Applied as the user types or pastes, so a disallowed character never reaches the field.
// A hyphen or maqaf joins two words (כהן-לוי), so it becomes a space rather than gluing them
// together. Spaces are collapsed but not trimmed, otherwise the space between two words could
// not be typed.
export function toHebrewName(value: string): string {
  return value
    .replace(/[-־]/g, ' ')
    .replace(NOT_HEBREW_NAME_CHAR, '')
    .replace(/ {2,}/g, ' ');
}
